export default function getMyAccountReturnsUrl() {
  const isProduction = window.location.host === "www.asos.com";
  const myAsosDomain = isProduction
    ? "https://my.asos.com"
    : "https://my.asosservices.com";

  return `${myAsosDomain}/my-account/returns`;
}
